<template>
  <v-container fluid>

        <v-row>
          <v-btn color="accent" small to="/create-advance-payment">
            <v-icon left dark>mdi-plus</v-icon>  Customer Advance
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="customers"
              :search="search"
            >
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Customer Name", value: "Name" },
      { text: "Advance Payments", value: "AdvancePayment" }
    ],
    customers: [],
  }),
  methods: {
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSuppliers();
  },
};
</script>